import { Download, X } from 'lucide-react';
import { useLang } from '@/providers/LangProvider';
import { useToast } from '@/providers/ToastProvider';
import { usePwaInstall } from '@/lib/hooks/usePwaInstall';
import { t } from '@/i18n/labels';
import { Button } from '@/components/ui/Button';
import { IconButton } from '@/components/ui/IconButton';

export function InstallPrompt() {
  const { lang } = useLang();
  const toast = useToast();
  const { canInstall, install, dismiss } = usePwaInstall();
  if (!canInstall) return null;

  return (
    <aside className="install-banner" role="dialog" aria-label={t(lang, 'installApp')}>
      <div className="install-banner-body">
        <div className="install-banner-title">{t(lang, 'installApp')}</div>
        <div className="install-banner-desc">{t(lang, 'installAppHint')}</div>
      </div>
      <div className="install-banner-actions">
        <Button
          variant="primary"
          size="sm"
          leadingIcon={<Download size={14} />}
          onClick={async () => {
            const outcome = await install();
            if (outcome === 'accepted') toast.success(t(lang, 'installApp'));
          }}
        >
          {t(lang, 'install')}
        </Button>
        <IconButton aria-label={t(lang, 'dismiss')} variant="ghost" size="sm" onClick={dismiss}>
          <X size={16} />
        </IconButton>
      </div>
    </aside>
  );
}
